export const ORG_ID = "939001"
export const USER = JSON.parse(localStorage.getItem("userData")) || {}
export const TWO_SECONDS_DELAY = 2000
export const LANDING_PAGE = "https://vomozflex.com/"
export const PRIVACY_POLICY_URL = "https://vomozflex.com/terms-and-conditions"
export const USER_REFERRER_URL = window.location.href || ""
